// extracted by mini-css-extract-plugin
export default {"container":"Chart_container__3U1KY","label":"Chart_label__cV516","value":"Chart_value__Zn6-I","chart":"Chart_chart__t5pJL"};